import request from "@/http";
/**
 *
 * @param {*} data
 * @returns
 */
// 显示bug清单
const getList = (data) => {
  let {
    mid_table_remark_001,
    mid_table_remark_002,
    mid_table_remark_004,
    mid_table_remark_005,
    mid_table_remark_006,
    mid_table_remark_007,
    mid_table_remark_008,
    mid_table_remark_009,
    mid_table_remark_009_like,
    mid_table_remark_010,
    mid_table_remark_011,
    mid_table_remark_012,
    mid_table_remark_013,
    mid_table_remark_013_like,
    pre_cmd_para_t1,
    begin_idx,
    // limit,
    id_public_user_info,
    isloading = false,
    type_middle_app = 80004,
    type_inner_app = 1001,
  } = data;
  return request.get({
    url: "duzikai_api_mgr_public_middle_table",
    data: {
      invoke_method: "public_load_middle_table_list",
      pre_db_para_begin_idx: begin_idx,
      // pre_db_para_length_4_list: limit,
      type_middle_app: type_middle_app,
      type_inner_app: type_inner_app,
      pre_db_para_middle_table_name: "public_middle_table_80004",
      id_public_user_info: id_public_user_info,
      pre_db_para_order_by_para: " time_insert desc ",
      mid_table_remark_001: mid_table_remark_001,
      mid_table_remark_002: mid_table_remark_002,
      mid_table_remark_004: mid_table_remark_004,
      mid_table_remark_005: mid_table_remark_005,
      mid_table_remark_006: mid_table_remark_006,
      mid_table_remark_007: mid_table_remark_007,
      mid_table_remark_008: mid_table_remark_008,
      mid_table_remark_009: mid_table_remark_009,
      mid_table_remark_009_like: mid_table_remark_009_like,
      mid_table_remark_010: mid_table_remark_010,
      mid_table_remark_011: mid_table_remark_011,
      mid_table_remark_012: mid_table_remark_012,
      mid_table_remark_013: mid_table_remark_013,
      mid_table_remark_013_like: mid_table_remark_013_like,
      is_online: 0,
      pre_cmd_para_t1: pre_cmd_para_t1
    },
    loading: {
      enabled: isloading,
    },
  });
};
// 创建BUG清单，修改
const createBug = (data) => {
  let {
    mid_table_remark_001,
    mid_table_remark_002,
    mid_table_remark_004,
    mid_table_remark_005,
    mid_table_remark_006,
    mid_table_remark_007,
    mid_table_remark_008,
    mid_table_remark_009,
    mid_table_remark_010,
    mid_table_remark_011,
    mid_table_remark_012,
    mid_table_remark_013,
    id_public_middle_table,
    id_public_user_info,
    pre_db_para_id_public_user_info,
    isloading = false,
    type_middle_app = 80004,
    type_inner_app,
    is_online,
  } = data;
  return request.post({
    url: "duzikai_api_mgr_public_middle_table",
    data: {
      invoke_method: "public_insert_or_update_middle_table",
      pre_db_para_id_public_middle_table: id_public_middle_table,
      id_public_user_info: id_public_user_info,
      pre_db_para_id_public_user_info:pre_db_para_id_public_user_info,
      mid_table_remark_001: mid_table_remark_001,
      mid_table_remark_002: mid_table_remark_002,
      mid_table_remark_004: mid_table_remark_004,
      mid_table_remark_005: mid_table_remark_005,
      mid_table_remark_006: mid_table_remark_006,
      mid_table_remark_007: mid_table_remark_007,
      mid_table_remark_008: mid_table_remark_008,
      mid_table_remark_009: mid_table_remark_009,
      mid_table_remark_010: mid_table_remark_010,
      mid_table_remark_011: mid_table_remark_011,
      mid_table_remark_012: mid_table_remark_012,
      mid_table_remark_013: mid_table_remark_013,
      pre_db_para_middle_table_name: "public_middle_table_80004",
      type_middle_app: type_middle_app,
      type_inner_app: type_inner_app,
      is_online: is_online,
    },
    loading: {
      enabled: isloading,
    },
  });
};
// 显示bug详情
const getDetail = (data) => {
  let {
    mid_table_remark_001,
    mid_table_remark_002,
    mid_table_remark_004,
    mid_table_remark_005,
    mid_table_remark_006,
    mid_table_remark_007,
    mid_table_remark_008,
    mid_table_remark_009,
    mid_table_remark_010,
    mid_table_remark_011,
    mid_table_remark_012,
    mid_table_remark_013,
    begin_idx,
    limit,
    id_public_user_info,
    id_public_middle_table,
    isloading = false,
    type_middle_app = 80004,
    type_inner_app = 1001,
  } = data;
  return request.get({
    url: "duzikai_api_mgr_public_middle_table",
    data: {
      invoke_method: "public_load_middle_table_list",
      pre_db_para_begin_idx: begin_idx,
      pre_db_para_length_4_list: limit,
      type_middle_app: type_middle_app,
      type_inner_app: type_inner_app,
      pre_db_para_middle_table_name: "public_middle_table_80004",
      // id_public_user_info: id_public_user_info,
      id_public_middle_table: id_public_middle_table,
      mid_table_remark_001: mid_table_remark_001,
      mid_table_remark_002: mid_table_remark_002,
      mid_table_remark_004: mid_table_remark_004,
      mid_table_remark_005: mid_table_remark_005,
      mid_table_remark_006: mid_table_remark_006,
      mid_table_remark_007: mid_table_remark_007,
      mid_table_remark_008: mid_table_remark_008,
      mid_table_remark_009: mid_table_remark_009,
      mid_table_remark_010: mid_table_remark_010,
      mid_table_remark_011: mid_table_remark_011,
      mid_table_remark_012: mid_table_remark_012,
      mid_table_remark_013: mid_table_remark_013,
    },
    loading: {
      enabled: isloading,
    },
  });
};

// 删除项目
const delBug = (data) => {
  let {
    id_public_middle_table,
    isloading = false,
    type_middle_app = 80004,
    type_inner_app = 1001,
  } = data;
  return request.post({
    url: "duzikai_api_mgr_public_middle_table",
    data: {
      invoke_method: "public_insert_or_update_middle_table",
      pre_db_para_id_public_middle_table: id_public_middle_table,
      pre_db_para_middle_table_name: "public_middle_table_80004",
      type_inner_app: type_inner_app,
      type_middle_app: type_middle_app,
      is_online: 111,
    },
    loading: {
      enabled: isloading,
    },
  });
};

/*
 * 查看跟踪记录
 * */
const TraceRecords = (data) => {
  let {
    begin_idx,
    // limit,
    id_public_user_info,
    mid_table_remark_001,
    mid_table_remark_002,
    mid_table_remark_006,
    mid_table_remark_009,
    mid_table_remark_010,
    mid_table_remark_012,
    isloading = false,
    type_middle_app = 80004,
    type_inner_app = 2002,
    is_online = 0,
  } = data;
  return request.get({
    url: "duzikai_api_mgr_public_middle_table",
    data: {
      invoke_method: "public_load_middle_table_list",
      pre_db_para_begin_idx: begin_idx,
      // pre_db_para_length_4_list: limit,
      type_middle_app: type_middle_app,
      type_inner_app: type_inner_app,
      pre_db_para_middle_table_name: "public_middle_table_80004",
      id_public_user_info: id_public_user_info,
      mid_table_remark_001: mid_table_remark_001,
      mid_table_remark_002: mid_table_remark_002,
      mid_table_remark_006: mid_table_remark_006,
      mid_table_remark_009: mid_table_remark_009,
      mid_table_remark_010: mid_table_remark_010,
      mid_table_remark_012: mid_table_remark_012,
      is_online: is_online,
      pre_db_para_order_by_para: " time_insert desc ",
    },
    loading: {
      enabled: isloading,
    },
  });
};

export default {
  getList,
  createBug,
  getDetail,
  delBug,
  TraceRecords,
};
